module.exports = __webpack_public_path__ + "media/luxury-2026/stone-living-02fa0648.jpg";